import {ConceptMapperApi, Configuration, HcxApi, LaunchpadApi} from '@invitae/stargate-ts-fetch'

import {STARGATE_BASE_PATH} from 'constants/urls'

// api-gw should be phased out in favor of the env injected STARGATE_BASE_PATH
const legacyConfiguration: Configuration = new Configuration({basePath: '/api-gw'})
const legacyLaunchpad = new LaunchpadApi(legacyConfiguration)
export const legacyStargate = Object.freeze({launchpad: legacyLaunchpad})

const configuration: Configuration = new Configuration({basePath: STARGATE_BASE_PATH})
export const conceptMapper = new ConceptMapperApi(configuration)
export const hcx = new HcxApi(configuration)
export const launchpad = new LaunchpadApi(configuration)
export const stargate = Object.freeze({conceptMapper, hcx, launchpad})
